<template>
  <div
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'airport' }"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize14">
            <th
              v-for="head in HEAD"
              :key="HEAD.title"
              class="column-title word_center"
              :width="head.width"
            >
              {{ head.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="row in vx_list">
            <tr
              v-if="vx_list.length"
              :key="row.billInfo.orderId"
              class="pointer fontSize14"
            >
              <!-- 序號 -->
              <td class="word_center">{{ row.billInfo.orderId }}</td>
              <!-- 司機呼號 -->
              <td class="word_center">
                <template v-if="row.driverInfo && row.driverInfo.callNumber">
                  <div>{{ row.driverInfo.callNumber }}</div>
                </template>
              </td>
              <!-- 預約時間 -->
              <td class="word_center">
                {{ row.billInfo.reservationTime }}
              </td>
              <!-- 乘客姓名電話 -->
              <td class="word_center">
                <div>{{ row.billInfo.passengerName }}</div>
                <div>{{ row.billInfo.passengerPhone }}</div>
              </td>
              <!-- 上車地點 -->
              <td class="word_center">{{ row.billInfo.onLocation }}</td>
              <!-- 下車地點 -->
              <td class="word_center">{{ row.billInfo.offLocation }}</td>
              <!-- 乘客備註 -->
              <td class="word_center">{{ row.billInfo.passengerNote }}</td>
              <!-- 目前進度 -->
              <td class="word_center">{{ orderState(row) }}</td>
              <!-- 檢視 -->
              <td class="word_center">
                <!-- <button
                  @click="$emit('showAirportTransfer', row.billInfo.orderId)"
                  class="mybtnstyle btn-danger"
                >
                  檢視
                </button> -->
                <button
                  @click="$emit('showAirportTransfer', row.billInfo.orderId)"
                  class="mybtnstyle btn-danger"
                >
                  檢視
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <!--頁籤-->
    <el-row>
      <el-col :offset="10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="onPageChange"
          :current-page="vx_reserveBeforePaging.currentPage"
          :page-count="vx_reserveBeforePaging.totalPages"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { airportTransfer } from '@/constants/tableHead'
import { getDay } from '@/utils/helper'

export default {
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_list: 'airportTransferList',
      vx_reserveBeforePaging: 'airportTransferPaging',
    }),
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setAirportTransferPagingCurrentPage:
        'setAirportTransferPagingCurrentPage',
    }),
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    onRecord(id) {
      this.$router.push({
        name: 'activityRecord',
        query: { id: id, type: '預約單' },
      })
    },
    phone(serviceName, managerName, passengerName, passengerPhone) {
      if (serviceName) {
        return `${serviceName ? serviceName : ''}-${
          passengerName ? passengerName : ''
        }-${passengerPhone ? passengerName : ''}`
      } else {
        return `${managerName ? managerName : ''}-${
          passengerName ? passengerName : ''
        }-${passengerPhone ? passengerPhone : ''}`
      }
    },
    orderState(row) {
      if (row.billInfo.result === 0) {
        return '已配對'
      } else if (row.billInfo.result === 1) {
        return '已載客'
      } else if (row.billInfo.driverCancel) {
        return '司機取消'
      } else if (row.billInfo.passengerCancel) {
        return '乘客取消'
      } else if (row.billInfo.result === 2) {
        return '完成'
      } else if (row.billInfo.result === 3) {
        return '未配對完'
      } else if (row.billInfo.result === 4) {
        return '等候乘客選擇司機'
      }
      return '尚未有司機接單'
    },
    getReservationTypeText(type) {
      if (type === 0) {
        return '一般預約'
      } else if (type === 1) {
        return 'LINE預約'
      } else if (type === 2) {
        return '機場接送'
      }
      return '未知類型'
    },
    day(date) {
      return getDay(date)
    },
    onPageChange(page) {
      this.vx_setAirportTransferPagingCurrentPage(page)
      this.vx_fetchList()
    },
  },
  created() {
    this.HEAD = airportTransfer
  },
}
</script>

<style scoped>
.table tbody td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/components/Airport.vue